import React, { memo } from 'react';
import { Clock } from 'lucide-react';

import styles from '../styles/AgentSettings.module.css';

const AgentTriggersTab = () => {
    return (
        <div className={styles.tabContent}>
            <div className={styles.section}>
                <h3 className={styles.sectionTitle}>Webhooks</h3>
                <p className={styles.sectionDescription}>
                    Configure webhooks to trigger your agent from external services. Each webhook gets a unique URL that can receive POST requests.
                </p>

                <div className={styles.comingSoon}>
                    <Clock size={18} className={styles.comingSoonIcon} />
                    <p className={styles.comingSoonText}>
                        This feature is currently in development and will be available soon.
                    </p>
                </div>
            </div>

            <div className={styles.section}>
                <h3 className={styles.sectionTitle}>Scheduled Tasks</h3>
                <p className={styles.sectionDescription}>
                    Set up recurring tasks that run on a schedule. Use cron expressions for precise timing control.
                </p>

                <div className={styles.comingSoon}>
                    <Clock size={18} className={styles.comingSoonIcon} />
                    <p className={styles.comingSoonText}>
                        This feature is currently in development and will be available soon.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default memo(AgentTriggersTab);
